import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getcalibrationdevicesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: (action?.payload?.endpoint?action?.payload?.endpoint:"calibrationdevices"), ...action.payload }),
		);
		yield put({
			type: types.GET_CALIBRATIONDEVICES_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CALIBRATIONDEVICES_ERROR,
			payload,
		});
	}
}

export function* getcalibrationdevicesWatcherSaga() {
	yield takeLatest(types.GET_CALIBRATIONDEVICES_START, getcalibrationdevicesHandlerSaga);
}

//delete

function* deletecalibrationdevicesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("calibrationdevices", action.payload),
		);
		yield put({
			type: types.DELETE_CALIBRATIONDEVICES_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_CALIBRATIONDEVICES_ERROR,
			payload,
		});
	}
}

export function* deletecalibrationdevicesWatcherSaga() {
	yield takeLatest(types.DELETE_CALIBRATIONDEVICES_START, deletecalibrationdevicesHandlerSaga);
}
